import Box from '@material-ui/core/Box';
import React from 'react';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';

import styled from 'styled-components';
const isEs = () =>
  window.$environment?.SERVICE_PROVIDER == 'webfleet' &&
  localStorage.getItem(window.$environment?.SERVICE_PROVIDER + 'Language') == 'es';

const LoaderContainer = styled(Box)`
  background: no-repeat url(${getMediaPath(isEs() ? mediaUrls.ajaxLoader_es : mediaUrls.ajaxLoader)}) center;
  ${({ theme }) => `${theme?.colors?.PRIMARY_MODAL_MAIN ? `background-color: ${theme?.colors?.PRIMARY_MODAL_MAIN};` : ``}`}
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Loader = (props) => {
  return <LoaderContainer />;
};

export default Loader;
